module.exports = __webpack_public_path__ + "img/satisfied.eff759e0.png";